<div fxLayout="column" class="full-width">
  <div
    class="header accent p-24"
    fxLayout="column"
    fxLayoutAlign="space-between start"
  >
    <div
      class="breadcrumb text-truncate h1 pl-12 mt-12"
      fxLayout="row"
      fxLayoutAlign="start center"
      [@animate]="{ value: '*', params: { x: '50px' } }"
    >
      <div fxLayout="row" fxLayoutAlign="start center">
        <mat-form-field appearance="outline" class="pr-sm-8" fxFlex="50">
          <mat-label>{{ "Year" | translate }}</mat-label>
          <input
            class="white-input"
            matInput
            readonly
            [(ngModel)]="selectedYear"
            [value]="selectedYear"
          />
          <input
            style="display: none"
            matInput
            readonly
            [matDatepicker]="picker"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="picker"
          ></mat-datepicker-toggle>
          <mat-datepicker
            (yearSelected)="chosenYearHandler($event, picker)"
            startView="multi-year"
            #picker
          >
          </mat-datepicker>
        </mat-form-field>
      </div>
    </div>
  </div>
  <div class="tabs">
    <mat-tab-group
      (selectedTabChange)="onTabChanged($event)"
      mat-align-tabs="start"
    >
      <mat-tab label="Type 1">
        <div
          [innerHTML]="data['1']?.html"
          style="padding: 10px; max-height: 80vh; overflow-y: scroll"
        ></div>
      </mat-tab>
      <mat-tab label="Type 2">
        <div
          [innerHTML]="data['2']?.html"
          style="padding: 10px; max-height: 80vh; overflow-y: scroll"
        ></div>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
